import { Variant } from "@amplitude/experiment-js-client";

import { type VariantValue } from "@/types";

export default (value?: VariantValue | Variant) => (typeof value === "string" ? { value } : value);
